import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import RevenueChart from '../../Model/Individual/StatisticsModel/RevenueChart';

import IntroMarkdown from './IntroMarkdown';

export default function RevenueChartRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const { t } = useLanguage();
  const { intro, thisYear, thisYearMaxPrice, xLabels, legendLabels, hideBar = false, hideLine = false, valueUnit = '' } = data;

  // 범례 라벨 — legendLabels 주입 시 대체 (유효회원 추이 등 재사용), 미전달 시 기존 매출 라벨 (회귀 0) //
  const thisYearLegend = legendLabels?.thisYear || t('statistics.revenue.thisYearSales');
  const lastYearLegend = legendLabels?.lastYear || t('statistics.revenue.lastYearSales');

  // 회원 추이(legendLabels 주입)는 툴팁 두 행에 계열 라벨(포함/제외) 표시. 증감률(전월대비)은 payload의 momPercent 선산출값으로 자동 표시 //
  const isMemberTrend = !!legendLabels;

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <LegendWrapper>
        {
          !hideBar &&
          <LegendItem>
            <LegendBar backgroundColor={theme.brand500} />
            <Text
              fontFamily='NotoSansKR-Medium'
              fontSize={14}
              color={theme.text}
              cursor='default'>
              {thisYearLegend}
            </Text>
          </LegendItem>
        }
        {
          !hideLine &&
          <LegendItem>
            <LegendDashedBar $color={theme.subText} />
            <Text
              fontFamily='NotoSansKR-Medium'
              fontSize={14}
              color={theme.subText}
              cursor='default'>
              {lastYearLegend}
            </Text>
          </LegendItem>
        }
      </LegendWrapper>
      <ChartContainer>
        <RevenueChart
          thisYear={thisYear}
          thisYearMaxPrice={thisYearMaxPrice}
          xLabels={xLabels}
          hideBar={hideBar}
          hideLine={hideLine}
          valueUnit={valueUnit}
          seriesLabels={isMemberTrend ? { current: thisYearLegend, prev: lastYearLegend } : null} />
      </ChartContainer>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const LegendWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const LegendItem = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const LegendBar = styled.div`
  width: 40px;
  height: 7px;

  border-radius: 2px;
  background-color: ${props => props.backgroundColor};
`;

const LegendDashedBar = styled.div`
  width: 40px;
  height: 0px;

  border-top: 2px dashed ${props => props.$color};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  overflow-x: auto;
`;
